module.exports = __webpack_public_path__ + "img/fb@3x.1b62fad9.webp";